module.exports = __webpack_public_path__ + "img/img-tabs-1-1.0774eef5.svg";